import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_money",
  "use": "icon-control_money-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_money\"><g transform=\"translate(2 1)\" stroke=\"currentColor\" fill=\"transparent\"><rect x=\".5\" y=\".5\" width=\"11\" height=\"13\" rx=\"2\" /><path stroke-linecap=\"round\" d=\"M4 4l2 2M8 4L6 6M4 8.5h4M4 6.5h4M6 6.5v4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol